"use client";

import { GraduationCap, BookOpen, Users } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CurrentScholarshipOpportunities() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const scholarships = [{
    id: 1,
    icon: GraduationCap,
    title: "Secondary Education Scholarship",
    description: "Full tuition support for promising students entering or continuing secondary school, covering fees, uniforms, and learning materials.",
    applicationLink: "#"
  }, {
    id: 2,
    icon: BookOpen,
    title: "University Bursary Program",
    description: "Financial assistance for exceptional students pursuing higher education degrees, including living expenses and essential academic resources.",
    applicationLink: "#"
  }, {
    id: 3,
    icon: Users,
    title: "Community Leadership Scholarship",
    description: "Support for students demonstrating strong community engagement and leadership potential, with mentorship and career guidance included.",
    applicationLink: "#"
  }];
  return <section ref={sectionRef} className="relative py-16 md:py-24 bg-[hsl(30,70%,10%)] text-[hsl(0,0%,95%)] overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
            Current Scholarship Opportunities
          </h2>
          <p className="text-lg text-[hsl(0,0%,80%)] max-w-2xl mx-auto">
            Explore our available scholarships designed to empower underprivileged students across Uganda.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {scholarships.map((scholarship, i) => {
          const Icon = scholarship.icon;
          return <Card key={scholarship.id} data-index={i} className={`bg-[hsl(0,0%,30%)] border border-[hsl(0,0%,40%)] text-[hsl(0,0%,95%)] hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(0,0,0,0.24)] transition-all duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? `animate-fade-in-up-delay-${i * 100}` : "opacity-0"}`}>
                <CardHeader>
                  <div className="w-16 h-16 rounded-lg bg-[hsl(120,80%,50%)]/20 flex items-center justify-center mb-4">
                    <Icon className="w-8 h-8 text-[hsl(120,80%,50%)]" />
                  </div>
                  <CardTitle className="text-xl font-display text-[hsl(0,0%,95%)]">
                    {scholarship.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-[hsl(0,0%,80%)] leading-relaxed">
                    {scholarship.description}
                  </p>
                </CardContent>
                <CardFooter>
                  <Link to={scholarship.applicationLink} className="w-full">
                    <Button className="w-full bg-[hsl(200,60%,55%)] text-white hover:bg-[hsl(200,65%,60%)] hover:-translate-y-0.5 hover:shadow-[0_4px_16px_rgba(0,0,0,0.16)] active:bg-[hsl(200,55%,50%)] active:translate-y-0 transition-all duration-[80ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(120,80%,50%)]/30">
                      Apply Now
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}